import * as z from 'zod';

// Types
import { TextBubbleZod } from '@/components/molecules/TextBubble/TextBubbleType';
import { TextZod } from '@/components/molecules/Text/TextType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';

export enum BubblesLayout {
  ALIGNED = 'aligned',
  STAGGERED = 'staggered',
  ALIGNED_FROM_RIGHT = 'aligned-from-right',
  STAGGERED_FROM_RIGHT = 'staggered-from-right',
}

const TextBubblesZod = z.object({
  __component: z.literal('block.bulles-de-textes'),
  id: z.number(),
  content: TextZod.nullable(),
  bubbles: z.array(TextBubbleZod).nullable(),
  waveWrapper: WaveWrapperZod.nullable(),
  bubblesLayout: z.enum(BubblesLayout).nullable(),
});

export { TextBubblesZod };
export type TextBubblesType = z.infer<typeof TextBubblesZod>;
